import { MenuIdProjects } from '@jira/navigation-apps__constants/src/MenuIdProjects.tsx';
import { SidebarIdProjectSettings } from '@jira/navigation-apps__constants/src/SidebarIdProjectSettings.tsx';
import { fieldSettingsRelayResource } from '@jira/router-resources__project-settings-fields/src/fieldSettingsRelayResource.tsx';
import { fieldSettingsPageEntrypoint } from '@jira/spa-apps__project-settings-fields/src/FieldsPage.entrypoint.tsx';
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { projectSettingsSoftwareFieldsRoute } from '@jira/router-routes__project-settings-product-routes-software-routes/src/projectSettingsSoftwareFieldsRoute.tsx';
import { softwareProjectLayout } from '@jira/platform__layouts-software-project-layout/src/index.tsx';
// eslint-disable-next-line jira/import/file-extension-required
import { createPageEntryPoint } from '@jira/platform__routing-create-route-entry-point';
import type { Route } from '@atlassian/react-resource-router';
import FieldSettingsPage, { LazyFieldsSettings } from './ui/project-settings/fields/index.tsx';
import { getSettingsNavigationResources } from './ui/project-settings/product-routes/common/index.tsx';

const projectSettingsSoftwareFieldsPageEntrypoint = createPageEntryPoint({
	main: fieldSettingsPageEntrypoint,
});

export const projectSettingsSoftwareFieldsRouteEntry: Route = createEntry(
	projectSettingsSoftwareFieldsRoute,
	() => ({
		group: 'project-settings-software',
		ufoName: 'project-settings.fields.jsw-tmp',
		// eslint-disable-next-line no-restricted-syntax
		component: FieldSettingsPage,
		layout: softwareProjectLayout,

		navigation: {
			menuId: MenuIdProjects,
			sidebarId: SidebarIdProjectSettings,
		},

		resources: [...getSettingsNavigationResources(), fieldSettingsRelayResource],
		forPaint: [LazyAtlassianNavigation, LazyFieldsSettings],

		bifrost: {
			bifrostGroup: 'shell-only',
		},

		entryPoint() {
			return projectSettingsSoftwareFieldsPageEntrypoint;
		},
	}),
);
